import {Injectable} from "@angular/core";

@Injectable()
export class ModalSpreaderService {
	base: any = null;
	child: any = null;
}
